import React, { useState } from 'react';
import { downloadFile } from '../../utils/downloadFiles';
import GetAppIcon from '@material-ui/icons/GetApp';
import { Tooltip, IconButton, CircularProgress } from '@material-ui/core';

const DownloadButton = ({name}) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleDownload = async () => {
        setLoading(true);
        setError(null);

        try {
            await downloadFile(name);
        } catch (err) {
            console.error("Error downloading file: ", err);
            setError('Failed to download the file.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title="Descargar">
            <IconButton onClick={handleDownload} disabled={loading}>
                {loading ? <CircularProgress size={24}/> : <GetAppIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default DownloadButton;
